import { render, staticRenderFns } from "./Intel.vue?vue&type=template&id=03674ae0&scoped=true&"
import script from "./Intel.vue?vue&type=script&lang=js&"
export * from "./Intel.vue?vue&type=script&lang=js&"
import style0 from "./Intel.vue?vue&type=style&index=0&id=03674ae0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03674ae0",
  null
  
)

export default component.exports